import { render, staticRenderFns } from "./ProductDescribingForm.vue?vue&type=template&id=1af55f54&scoped=true"
import script from "./ProductDescribingForm.vue?vue&type=script&lang=js"
export * from "./ProductDescribingForm.vue?vue&type=script&lang=js"
import style0 from "./ProductDescribingForm.vue?vue&type=style&index=0&id=1af55f54&prod&lang=scss&scoped=true"
import style1 from "./ProductDescribingForm.vue?vue&type=style&index=1&id=1af55f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af55f54",
  null
  
)

export default component.exports